<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: 'AppView'
}
</script>

<style scoped>

</style>
